import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../api';

const s = {
  page: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#eff6ff' },
  card: { background: '#fff', padding: 40, borderRadius: 16, boxShadow: '0 4px 24px rgba(0,0,0,0.08)', width: '100%', maxWidth: 420 },
  title: { fontSize: 28, fontWeight: 700, color: '#1e3a8a', marginBottom: 8 },
  sub: { color: '#64748b', marginBottom: 28 },
  label: { display: 'block', marginBottom: 6, fontWeight: 600, color: '#374151' },
  input: { width: '100%', padding: '12px 14px', borderRadius: 8, border: '1.5px solid #e2e8f0', fontSize: 16, marginBottom: 18, outline: 'none', boxSizing: 'border-box' },
  btn: { width: '100%', padding: '14px', background: '#2563eb', color: '#fff', border: 'none', borderRadius: 8, fontSize: 16, fontWeight: 700, cursor: 'pointer' },
  error: { color: '#ef4444', marginBottom: 16, fontSize: 14 },
  success: { color: '#16a34a', background: '#f0fdf4', border: '1px solid #bbf7d0', padding: '12px 16px', borderRadius: 8, marginBottom: 16, fontSize: 14 },
  link: { textAlign: 'center', marginTop: 20, color: '#64748b' }
};

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return setError('Passwords do not match');
    if (password.length < 12) return setError('Password must be at least 12 characters');
    setLoading(true);
    setError('');
    try {
      await api.post('/auth/reset-password', { token, password });
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  if (!token) return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.error}>Invalid reset link. Please request a new one.</div>
        <div style={s.link}><Link to="/forgot-password">Request new link</Link></div>
      </div>
    </div>
  );

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.title}>Reset Password</div>
        <div style={s.sub}>Enter your new password below</div>
        {error && <div style={s.error}>{error}</div>}
        {success ? (
          <>
            <div style={s.success}>Password reset successfully!</div>
            <div style={s.link}><Link to="/login">Sign in with new password</Link></div>
          </>
        ) : (
          <form onSubmit={submit}>
            <label style={s.label}>New Password</label>
            <input style={s.input} type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Min 12 characters" required />
            <label style={s.label}>Confirm Password</label>
            <input style={s.input} type="password" value={confirm} onChange={e => setConfirm(e.target.value)} placeholder="Repeat new password" required />
            <button style={s.btn} disabled={loading}>{loading ? 'Resetting...' : 'Reset Password'}</button>
          </form>
        )}
        <div style={s.link}><Link to="/login">Back to Sign In</Link></div>
      </div>
    </div>
  );
}
